import { Checkbox } from './ui/checkbox';

export default function PrivacyCheckbox({ checked, onCheckedChange }) {
  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id="privacy-terms"
        data-testid="privacy-terms-checkbox"
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="mt-1 border-[#d1af6a]/50 data-[state=checked]:bg-[#d1af6a] data-[state=checked]:border-[#d1af6a] flex-shrink-0"
      />
      <label htmlFor="privacy-terms" className="text-[#c8c6c4] text-sm cursor-pointer select-none leading-relaxed">
        Ich habe die{' '}
        <a 
          href="/datenschutz" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#d1af6a] hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          Datenschutzerklärung
        </a>{' '}
        und{' '}
        <a 
          href="/agb" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#d1af6a] hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          AGB
        </a>{' '}
        gelesen und bin damit einverstanden, dass meine Daten zur Bearbeitung meiner Anfrage gemäß DSGVO verarbeitet werden. *
      </label>
    </div>
  );
}
